<template>
  <div class="frame">
    <div class="artboard">
      <div class="artboard__inner">
        <img class="artboard__bg" :src="backgroundSrc" alt="" aria-hidden="true">
        <img class="artboard__logo" :src="logoSrc" alt="HOW2AI">
        <LanguageToggle class="artboard__language"/>
        <slot/>
      </div>
    </div>
  </div>
</template>

<script>
import {mapState} from "vuex";
import LanguageToggle from "@/components/LanguageToggle.vue";

export default {
  name: 'ArtboardFrame',
  components: {LanguageToggle},
  computed: {
    ...mapState(['brandConfig']),
    assetBrand() {
      return this.brandConfig.assetBrand || this.brandConfig.brand;
    },
    backgroundSrc() {
      return require(`@/brand/${this.assetBrand}/assets/background.webp`);
    },
    logoSrc() {
      return require(`@/brand/${this.assetBrand}/assets/logo-lockup.png`);
    }
  }
}
</script>

<style scoped>
.frame {
  min-height: 100vh;
  min-height: 100svh;
  display: flex;
  justify-content: center;
  background-color: var(--ground);
}

/* Spans the full viewport height, with the artwork held against the bottom. --u already
   grows to close most of any gap; whatever is left opens above the artwork, where the
   design's own header band is pure white, so the join is invisible. */
.artboard {
  width: calc(375 * var(--u));
  min-height: 100vh;
  min-height: 100svh;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  overflow: hidden;
  background-color: #FFFFFF;
  /* Invisible on a phone, where the artboard fills the viewport. It only shows on a
     desktop window, where it makes the capped strip read as a deliberate canvas rather
     than a page that failed to fill the width. */
  box-shadow: 0 calc(2 * var(--u)) calc(28 * var(--u)) rgba(46, 74, 48, 0.16);
}

.artboard__inner {
  position: relative;
  flex: none;
  width: 100%;
  height: calc(812 * var(--u));
}

.artboard__bg {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  display: block;
}

.artboard__logo {
  position: absolute;
  top: calc(28 * var(--u));
  left: calc(107 * var(--u));
  width: calc(158 * var(--u));
  height: calc(44 * var(--u));
}

.artboard__language {
  position: absolute;
  top: calc(38 * var(--u));
  right: calc(16 * var(--u));
}
</style>
